/**
 * 3DIDS - Sincronización de variante
 *
 * Caso 1: URL con ?variant=XXX → actualiza H1 y descripción al cargar la página
 * Caso 3a: click en .chip-st (picker custom de agregado-custom.liquid)
 *          → el handler nativo añade .is-active-st antes de que burbujee a document
 * Caso 3b: variant:update (picker estándar de Shopify, fallback)
 *
 * Datos: snippet 3dids-variant-data.liquid inyecta JSON con id, options, v_title, v_description
 */
(() => {
  const dataScript = document.querySelector('[id^="3dids-VariantData-"]');
  if (!dataScript) return;

  /** @type {Array<{id: number, options: string[], v_title: string, v_description: string|null}>} */
  const variants = JSON.parse(dataScript.textContent || '[]');
  if (!variants.length) return;

  const updateUI = (/** @type {{v_title: string, v_description: string|null}} */ variant) => {
    const h1 = /** @type {HTMLElement|null} */ (
      document.querySelector('.js-3dids-product-title') ||
      document.querySelector('h1, .product-information h1')
    );
    if (h1) h1.innerText = variant.v_title;

    const desc = document.querySelector('.js-3dids-product-description');
    if (desc) desc.innerHTML = variant.v_description || '';
  };

  // Caso 1: carga inicial con ?variant=XXX en la URL
  window.addEventListener('load', () => {
    const urlParams = new URLSearchParams(window.location.search);
    const vId = urlParams.get('variant')
      || /** @type {HTMLInputElement|null} */ (document.querySelector('input[name="id"]'))?.value
      || null;
    if (vId) {
      const variant = variants.find(v => String(v.id) === String(vId)) ?? null;
      if (variant) updateUI(variant);
    }
  });

  // Caso 3a: picker custom (agregado-custom.liquid) — chips de talla
  // El handler nativo en grid añade .is-active-st ANTES de que el click burbujee a document
  document.addEventListener('click', (e) => {
    const chip = /** @type {Element} */ (e.target)?.closest?.('.chip-st');
    if (!chip) return;

    // Leer estado tras el handler nativo (ya actualizado)
    const sizeVal = /** @type {HTMLElement} */ (document.querySelector('.chip-st.is-active-st'))?.dataset.sizeOption?.trim();
    const colorVal = /** @type {HTMLElement|null} */ (document.querySelector('.swatch-st[aria-checked="true"]'))?.dataset.color?.trim() || null;

    if (!sizeVal) return;

    // options[0] = talla, options[1] = color (si existe)
    const variant = variants.find(v =>
      v.options?.[0]?.trim() === sizeVal &&
      (!colorVal || v.options?.[1]?.trim() === colorVal)
    );

    if (variant) updateUI(variant);
  });

  // Caso 3b: picker estándar de Shopify (variant:update) — fallback si se usa en otra plantilla
  const section = document.querySelector('variant-picker')?.closest('.shopify-section');
  (section ?? document).addEventListener('variant:update', (/** @type {Event} */ e) => {
    const variantId = /** @type {CustomEvent} */ (e).detail?.resource?.id;
    if (!variantId) return;
    const variant = variants.find(v => String(v.id) === String(variantId)) ?? null;
    if (variant) updateUI(variant);
  });
})();
